import styled from 'styled-components';

export const ActionsHeaderWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    align-items: center;
`;

export const ActionIconWrapper = styled.div`
    img {
        filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
    }
`;